import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

const COUNT_BADGE_OVERFLOW_AT = 99;

export type CountBadgeProps = {
  count: number;
} & Pick<ComponentProps<'div'>, 'children' | 'className' | 'style'>;

export const CountBadge = memo(({ className, count, children, style }: CountBadgeProps) => {
  return (
    <div className={cn('relative z-[9] mx-auto w-fit', className)} style={style}>
      {count > 0 && (
        <div className="absolute left-4 z-[2] flex h-4 min-w-[16px] items-center justify-center rounded-full border ads:border-ads-gray-1 border-gray-1 ads:bg-error bg-red-9 px-1 font-bold text-10 text-white uppercase tracking-wide">
          {count > COUNT_BADGE_OVERFLOW_AT ? '+99' : count}
        </div>
      )}

      {children}
    </div>
  );
});

CountBadge.displayName = 'CountBadge';
